import axios from './axios.service';
import config from './../config';
import { getQueryStringFromObject, getRequestHeaders } from './common.service';

async function getProfile() {
  try {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/profile', { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
  } catch (error) {
      return { error: error.message };
  }
}

async function updateProfile(payload) {
  let response;
  try {
      let headers = getRequestHeaders();
      response = await axios.patch( config.SERVER_BASE_URL + '/profile', payload, { headers: headers });
  } catch (error) {
      return error.response.data;
  }
  return response.data;
}

export {
    getProfile,
    updateProfile,
}
